import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {select} from "@angular-redux/store";
import {isNullOrUndefined} from "util";
import {edsEnvConfiguration} from "../../../environments/edsEnvConfiguration";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActionsService} from "../../Redux/Actions/actions.service";
import {setWindowTitle} from "../../commonUtil";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'edsng-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {

  @select(["appProjectTypes"]) menuSideBar;
  tempDesc = "This is a short text to describe the card or the set of applications that are available in the group";
  tempDescTitle = "Title to summarize card contents";
  srcMap = {
    "icon-Power-Converter_1": "assets/icons/sidebarIcons/01-Power-Converter_1.svg",
    "icon-Battery-Charger_1": "assets/icons/sidebarIcons/02-Battery-Charger_1.svg",
    "icon-LED-Driver_1": "assets/icons/sidebarIcons/03-LED-Driver_1.svg",
    "icon-Photovoltaic_1": "assets/icons/sidebarIcons/04-Photovoltaic_1.svg",
    "icon-Signal-Conditioning_1": "assets/icons/sidebarIcons/05-Signal-Conditioning_1.svg",
    "icon-RF-Design_1": "assets/icons/sidebarIcons/06-RF-Design_1.svg",
    "icon-Simulators": "assets/icons/sidebarIcons/09-Simulators.svg",
    "icon-Smart-Selectors_prop-L": "assets/icons/sidebarIcons/07-Smart-Selectors_prop-L.svg",
    "icon-Tune_1": "assets/icons/sidebarIcons/10-Tune_1.svg"
  };
  background = ['#FFD200', '#3CB4E6', '#E6007E'];
  newHome = false;
  constructor(private router: Router,
              private snack: MatSnackBar,
              private act: ActionsService,
              public translate: TranslateService
  )   {
  }

  ngOnInit() {
    this.translate.get(['COMMON.eDesignSuite'])
      .subscribe(translations => {
        setWindowTitle(null, this.translate);
      });
  }

  private canBeOpened(child) {
    // return child !== null && (child.start === true || child.create === true || child.go === true || child.download === true);
    return !isNullOrUndefined(child.catalog) && !isNullOrUndefined(child.classType) || !isNullOrUndefined(child.url);
  }

  private paramToString(obj: any): string {
    return isNullOrUndefined(obj) ? "[]" : JSON.stringify(obj);
  }

  openableItems(item: any[]) {
    return item.filter(x => this.canBeOpened(x));
  }

  getActionList(item: any[]): any[] {
    return item ? item.filter(x => this.canBeOpened(x)).map(y => this._toTargetUrl(y)) : [];
  }

  _toTargetUrl(item): {label: string; url: string; target} {
    const uri = item.url ? (item.url as string).trim().toLowerCase() : '';
    const label = item.label;
    const target = (!isNullOrUndefined(item.url)) ? '_blank' : '_self';
    const url = (isNullOrUndefined(item.url) && !isNullOrUndefined(item.catalog) && !isNullOrUndefined(item.classType))
                ? ["#/app", item.classType, item.catalog, "filter",  this.paramToString(item.filterTopologies)].join('/')
                : ((uri.startsWith("http") || uri.startsWith("/")) // TODO: Da veriicare la condizione successiva (probabilmente l'else non si verifica mai)
                  ? item.url
                  : (edsEnvConfiguration.edsUrl + item.url));
    return {
      label,
      url,
      target,
    };
  }
}
